import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send_to_back",
  "use": "icon-send_to_back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-send_to_back\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M6,16H17v1H6Zm7-5h4V10H13Zm-3-1H6v1h4ZM6,6V9h5v4.6L9.38,12l-.71.71,2.83,2.83,2.83-2.83L13.62,12,12,13.6V9h5V6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol